const FIELD_UPDATE_SUCCESS = 'app/loading/UPDATE_FIELD_SUCCESS'

export { FIELD_UPDATE_SUCCESS }
